import { Dashboard } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material";

export const DashboardIcon = (props: SvgIconProps) => (<Dashboard {...props}/>);